import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-changelog-page',
  templateUrl: './changelog-page.component.html',
  styleUrls: ['./changelog-page.component.css']
})
export class ChangelogPageComponent implements OnInit {

  constructor(
    private titleService: Title
  ) { }

  ngOnInit(): void {
    this.titleService.setTitle('Changelog | ' + environment.title);
  }

}
